import { STATUS } from './CourseService';

const getLocale = ( item, locale = 'en-US' ) => {
    const locales = item?.locales || item;

    // Just incase we check that locales exists and has at least on element
    if ( !locales || ( Array.isArray( item ) && item.length == 0 ) || ( !Array.isArray( item ) && Object.values( item ).length == 0 ) ) {
        return;
    }

    // Find the locale item matching the locale code. Default #1 is en-US. Default #2 is first localization
    let matchingLocale = Array.isArray( locales ) ?
        locales.find( c => c.locale === locale )   
            || locales.find( c => c.locale === 'en-US' )  
                || locales[ 0 ] : 
        locales[ locale ]                         
            || locales[ 'en-US' ] 
                || Object.values( locales )[ 0 ]; 
                
    return matchingLocale;
};

const getLocalizedName = ( item, locale = 'en-US' ) => {
    const matchingLocale = getLocale( item, locale );

    if ( matchingLocale ) {
        return matchingLocale.name || '';
    } else {
        return '';
    }
};

const getLocalizedDescription = ( item, locale = 'en-US' ) => {
    const matchingLocale = getLocale( item, locale );
    
    if ( matchingLocale ) {
        return matchingLocale.description || '';
    } else {
        return '';
    }
};

const getCourseStatus = ( enrollment ) => {
    if ( !enrollment || enrollment === null ) {
        return STATUS.ASSIGNED;
    } else {
        return enrollment.status;
    }
};

const getLearningObjectStatus = ( assignment ) => {
    if ( !assignment || assignment === null ) {
        return STATUS.ASSIGNED;
    } else {
        return assignment.status;
    }
};

const getLocalizedLearningObjects = ( course, locale = 'en-US' ) => {  
    if ( course?.learningObjects?.edges ) {    
        const learningObjects = course.learningObjects.edges.map( item => { 
            return {    
                id: item.node.id, 
                key: item.node.id, 
                assignment: item.assignment,
                courseId: course.id,
                format: item.node.format,
                expireAt: item.node.expireAt,
                content: item.node.content,
                status: getLearningObjectStatus( item.assignment ),
                name: getLocalizedName( item.node, locale ),
                description: getLocalizedDescription( item.node, locale )
            };
        } );  

        return learningObjects;      
    } else {
        return [];
    }
};

const formatCourseForLocale = ( course, locale ) => {
    return {
        id: course.node.id, 
        key: course.node.id,  
        heroImage: course.node.heroImage?.url || '',
        name: getLocalizedName( course.node, locale ),
        description: getLocalizedDescription( course.node, locale ),
        status: getCourseStatus( course.enrollment ),
        learningObjects: getLocalizedLearningObjects( course.node, locale )
    };
};
 
export default formatCourseForLocale;
